import React from 'react';
import { Helmet } from 'react-helmet-async';
import ErrorBoundary from '../../../ErrorBoundary';
import ContentShadow from '../_partials/ContentShadow';
import { VideoPlayer } from '../../../VideoPlayer/LoadableVideoPlayer';
import DeviationMediaService from '../../../utils/DeviationMediaService';
function getSource(media) {
    if (!media || media.length === 0) {
        return null;
    }
    // TODO: pick the size that fits the screen size the best
    // get the largest quality available for now
    var maxQuality = media
        .map(function (file) { return parseInt("" + file.quality, 10); })
        .sort(function (a, b) { return b - a; })[0];
    return media.find(function (file) {
        return file.quality ? file.quality.startsWith("" + maxQuality) : false;
    });
}
export var FilmFullView = function (_a) {
    var deviation = _a.deviation, height = _a.height, width = _a.width;
    var videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    if (!videoFile) {
        return null;
    }
    var previewFile = DeviationMediaService.getDeviationFile(deviation, 'preview');
    return (React.createElement(ErrorBoundary, null,
        React.createElement(ContentShadow, { content: videoFile, containerSize: { width: width, height: height } },
            React.createElement(Helmet, null,
                previewFile && (React.createElement("link", { rel: "preload", href: previewFile.src, as: "image" })),
                React.createElement("link", { rel: "preload", href: videoFile.src, as: "video" })),
            React.createElement(VideoPlayer, { width: width, height: height, src: videoFile.src, loadingCover: previewFile && previewFile.src, autoPlay: false }))));
};
FilmFullView.displayName = 'FilmFullView';
export default FilmFullView;
//# sourceMappingURL=Film.js.map